module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/analysis_3@2x-5df2e2a1c7d9412da0969af1320ef0bb.png";